import { useQuery } from "react-apollo"
import gql from "graphql-tag"
import { manualIntegrations, isCmsConnected } from "../../shared/utils"
import { CMS_INTEGRATIONS_QUERY } from "@modules/graphql/queries"

const keyBy = (array, key) =>
  (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {})

export const ACTIVE_CMS_INTEGRATION = gql`
  query activeCmsIntegrationsForSite($siteId: UUID!) {
    activeCmsIntegrationsForSite(siteId: $siteId) {
      id
      resourceId
      vendor
      status
      config
      environmentVariablesFeatureStatus
      webhookFeatureStatus
      extensionFeatureStatus
    }
  }
`

export const useCmsIntegration = siteId => {
  const { loading, error, data } = useQuery(CMS_INTEGRATIONS_QUERY, {
    variables: {
      siteId,
    },
    skip: !siteId,
  })

  const noCmsIntegrations =
    !siteId ||
    (data &&
      data.cmsIntegrationsForSite &&
      !data.cmsIntegrationsForSite.find(isCmsConnected))

  const {
    loading: activeCmsLoading,
    error: activeCmsError,
    data: activeCmsData,
  } = useQuery(ACTIVE_CMS_INTEGRATION, {
    skip: noCmsIntegrations,
    variables: {
      siteId,
    },
  })

  let cmsIntegrationsForSite = data && data.cmsIntegrationsForSite

  if (
    activeCmsData &&
    activeCmsData.activeCmsIntegrationsForSite &&
    activeCmsData.activeCmsIntegrationsForSite.length > 0
  ) {
    const { activeCmsIntegrationsForSite } = activeCmsData

    const activeCmsMap = keyBy(activeCmsIntegrationsForSite, `vendor`)

    cmsIntegrationsForSite =
      cmsIntegrationsForSite &&
      cmsIntegrationsForSite.map(cmsIntegration => {
        if (cmsIntegration.connected) {
          return {
            ...cmsIntegration,
            ...activeCmsMap[cmsIntegration.name],
          }
        }

        return cmsIntegration
      })
  }

  return siteId
    ? {
        cmsIntegrations: cmsIntegrationsForSite,
        loading: loading || activeCmsLoading,
        error: error || activeCmsError,
      }
    : { cmsIntegrations: manualIntegrations, loading: false, error: undefined }
}
